"use client";

import { useEffect, useRef, useState } from "react";

import dynamic from "next/dynamic";

const AllianceBenefits = dynamic(() => import("./AllianceBenefits"), { ssr: false });
const Faq = dynamic(() => import("./Faq"), { ssr: false });
const SubscriptionBar = dynamic(() => import("./SubscriptionBar"), { ssr: false });

export default function DeferredHomeSections() {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShow(true);
          observer.disconnect();
        }
      },
      { rootMargin: "300px" },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sentinelRef} className="flex flex-col gap-10">
      {show && (
        <>
          <AllianceBenefits />
          <Faq />
          <SubscriptionBar />
        </>
      )}
    </div>
  );
}
